import { css } from '@emotion/react'
import styled from '@emotion/styled'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorIcon from '@mui/icons-material/Error'
import { FormControl } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import InputBase from '@mui/material/InputBase'
import { getThemeSpacing } from '../styles/appTheme'
import { maxWindowWidth } from '../styles/breakpoints'
import { palette } from '../styles/colors'
import shape from '../styles/shape'
import { APP_FONT } from '../theme'

export const StyledFormRoot = styled('article')({
    maxHeight: '100%',
    display: 'flex',
    fontSize: '1rem',
    textAlign: 'center',
    justifyContent: 'center',
    padding: getThemeSpacing(2),
    flexDirection: 'column',
})

export const StyledFormRow = styled('div')({
    flexDirection: 'column',
    justifyContent: 'left',
    textAlign: 'left',
    fontSize: '13px',
    paddingBottom: getThemeSpacing(2),
})

export const SuccessMessageContainer = styled('div')({
    backgroundColor: 'rgb(237, 247, 237)',
    fontWeight: 'bold',
    color: '#4caf50',
    lineHeight: '1.43',
    borderRadius: shape.borderRadius,
    padding: '8px 16px',
    marginLeft: '8px',
    marginRight: '8px',
    marginBottom: '8px',
    fontSize: '1rem',
})

export const StyledWarningText = styled('span')({
    color: palette.mfcWarning,
})

export const inputStyles = css({
    fontSize: 13,
    fontWeight: 500,
    flex: 1,
    fontFamily: APP_FONT,
})

export const muiInputStyles = css({
    '& .MuiInputBase-input': {
        fontFamily: APP_FONT,
        fontSize: 14,
        fontWeight: 500,
    },
    '& .MuiInputLabel-root': {
        fontFamily: APP_FONT,
        fontSize: 14,
        fontWeight: 500,
    },
    '& .MuiNativeSelect-select': {
        fontFamily: APP_FONT,
        fontSize: 14,
        fontWeight: 500,
    },
})

export const StyledCheckbox = styled(Checkbox)({
    fontSize: '1em',
    fontWeight: 500,
    color: 'rba(61,73,61)',
})

export const StyledFormControlLabel = styled(FormControlLabel)({
    '.MuiFormControlLabel-label': {
        fontSize: '1em',
        fontWeight: 500,
    },
})

export const StyledCheckmarkIcon = styled(CheckCircleOutlineIcon)({
    fontSize: 20,
    color: palette.greenMFC,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: getThemeSpacing(0.5),
})

export const StyledErrorIcon = styled(ErrorIcon)({
    fontSize: 20,
    color: palette.mfcWarning,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: getThemeSpacing(0.5),
})

export const StyledSuccessMessage = styled('span')({
    fontSize: 13,
    color: palette.greenMFC,
    display: 'inline-block',
    verticalAlign: 'middle',
})

export const StyledErrorMessage = styled('span')({
    fontSize: 13,
    color: palette.mfcWarning,
    display: 'inline-block',
    verticalAlign: 'middle',
})

export const ValidationMessageContainer = styled('section')({
    marginBottom: getThemeSpacing(1),
})

export enum FORM_PANE_STATES {
    landing = 'landing',
    success = 'Success',
    error = 'We encountered an error',
}

export const dropdownStyles = css({
    '& .MuiNativeSelect-select': {
        padding: `${getThemeSpacing(1)} ${getThemeSpacing(1.75)}`,
        fontFamily: APP_FONT,
        fontSize: '0.875rem',
        fontWeight: 500,
        overflow: 'ellipsis',
        lineHeight: '16px',
        [maxWindowWidth(400)]: {
            lineHeight: '15px',
            paddingLeft: getThemeSpacing(1),
        },
    },
})

export const StyledInputBase = styled(InputBase)({
    border: `1px solid var(--drawer-divider)`,
    borderRadius: getThemeSpacing(0.5),
})

export const StyledFormControl = styled(FormControl)({
    font: 'inherit',
    marginTop: getThemeSpacing(1),
    marginLeft: getThemeSpacing(1),
    marginRight: getThemeSpacing(1),
    minWidth: 120,
    '& .MuiInputLabel-root': {
        fontFamily: 'inherit',
    },
    '& .MuiNativeSelect-select': {
        fontFamily: APP_FONT,
        padding: 14,
        '& .MuiOutlinedInput-root': {
            fontFamily: APP_FONT,
        },
    },
})

export const formControlStyles = css({
    width: '100%',
})
